import React from 'react'
import Navbar from '../inc/Navbar'
import ScrollToTop from "react-scroll-to-top"
import {Link } from "react-router-dom";

import front_college from "../images/front.jpg";
import buildingcollege from "../images/mmcpnadia Building.jpg";
import interiorclass from "../images/class.jpg"
function Gallery() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />

            <div className='color'>
                <div className="album py-1">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"> Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Gallery</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

            <ScrollToTop smooth top="100" color="Gray" />

            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 mt-3">
                            <img src={front_college} className="card-img-top" alt="Maa Manasha College of Pharmacye" />


                            </div>
                             <div className="col-md-4 mt-3">
                            <img src={buildingcollege} className="card-img-top" alt="Maa Manasha College of Pharmacy" />


                            </div>
                             <div className="col-md-4 mt-3">
                            <img src={interiorclass} className="card-img-top" alt="best pharmacy college in Kaliganj" />


                            </div>

                        </div>
                    </div>
                </div>
                <br/>
            </div>
            )
}

            export default Gallery